import { ListboxOption } from '@headlessui/react'
import classNames from 'classnames'
import React from 'react'
import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'
import { initialFilterState } from './DropdownList'

interface IDropdownListCreateOptionProps {
  filter: string
  textField: string
  setFilter: Function
  minLength?: number
  maxLength?: number
}

const DropdownListCreateOption: React.FunctionComponent<
  IDropdownListCreateOptionProps
> = ({ textField, filter, setFilter, minLength, maxLength }) => {
  const { t } = useUIComponentsContext()
  const trimmed = filter.trim()

  const tooShort = typeof minLength === 'number' && trimmed.length < minLength
  const tooLong = typeof maxLength === 'number' && trimmed.length > maxLength
  const isInvalid = tooShort || tooLong

  const errorMessage = tooShort
    ? t('validation.min', [String(minLength)])
    : tooLong
      ? t('validation.max', [String(maxLength)])
      : null

  return (
    <ListboxOption
      as="button"
      disabled={isInvalid}
      className={({ focus }) =>
        classNames([
          'relative p-3 w-100 border-t border-t-oxford-gray-200',
          {
            'cursor-pointer': !isInvalid,
            'cursor-not-allowed opacity-60': isInvalid,
            'text-primary bg-electric-violet-50': focus && !isInvalid,
            'text-oxford-gray-800': !focus || isInvalid
          }
        ])
      }
      value={{
        create: true,
        [textField]: trimmed
      }}
      onClick={() => {
        if (isInvalid) return
        setFilter(initialFilterState)
      }}
    >
      {() => (
        <div className="block truncate text-xs text-left">
          <span className="text-primary">
            {t('buttons.createOption')}{' '}
            <span className="font-semibold">{filter}</span>?
          </span>
          {errorMessage && (
            <span className="block text-watermelon-800 mt-1">
              {errorMessage}
            </span>
          )}
        </div>
      )}
    </ListboxOption>
  )
}

export default DropdownListCreateOption
